import React from 'react';

import classnames from 'classnames/bind';
import styles from './MembershipCard.module.scss';
import { Skeleton } from '@mui/material';

const CN = 'membership-card';
const nameClassName = `${CN}__name`;
const priceClassName = `${CN}__price`;

const cx = classnames.bind(styles);

export const MembershipCardSkeleton: React.FC = () => (
  <div className={ cx(CN) }>
    <Skeleton width={ 50 } variant='text' className={ cx(nameClassName) }/>
    <Skeleton width={ 100 } className={ cx(priceClassName) } variant='rectangular'/>
    <Skeleton variant='text' className={ cx(nameClassName) }/>
    <Skeleton variant='text' className={ cx(nameClassName) }/>
    <Skeleton variant='text' className={ cx(nameClassName) }/>
    <Skeleton variant='text' className={ cx(nameClassName) }/>
    <Skeleton variant='text' className={ cx(nameClassName) }/>
    <Skeleton className={ cx(priceClassName) } height={ 50 } variant='rectangular'/>

  </div>
);
